import { useThemeStore } from "@stores/theme.store";
import moment from "moment-timezone";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "@assets/css/custom/rapor-mtw.css";
moment.locale("id");
export const FinalReportCardMTWPage = () => {
  const { state } = useLocation();
  const { setHeader, setAppBar } = useThemeStore((state) => state);

  const currentMonth = new Date().getMonth() + 1;
  const currentYear = new Date().getFullYear();

  const getCategoryName = (kategori: string) => {
    switch (kategori) {
      case "العلوم العامة":
        return "Ilmu Pengetahuan Umum";
      case "العلوم الشرعية":
        return "Ilmu Syar`i";
      case "العلوم اللغوية":
        return "Ilmu Bahasa";
      default:
        return "Kedisiplinan";
    }
  };

  useEffect(() => {
    setAppBar({ title: "Rapor MTW", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Rapor MTW",
    });
  }, [setHeader, setAppBar]);

  return (
    <>
      <div className="tw-flex tw-justify-center">
        <div
          className="tw-origin-top tw-w-[670px] tw-scale-[0.5] md:tw-scale-100 md:tw-w-[700px]"
          style={{
            transformOrigin: "top center",
          }}
        >
          <div className="tw-w-[670px] md:tw-w-[700px]">
            <div className="tw-bg-other-100 tw-rounded-lg tw-px-2 tw-py-4">
              {/* header */}
              <div className="tw-w-full tw-text-center tw-pb-2">
                <div className="tw-mb-2 tw-text-sm md:tw-text-base">
                  كشف الدرجات للمرحلة المتوسطة
                </div>
                <div className="tw-text-xs md:tw-text-sm">
                  بمعهد الإرشاد الإسلامي
                </div>
              </div>

              <div className="tw-w-full tw-py-1 tw-text-[10px] md:tw-text-base">
                <div className="tw-flex tw-justify-between tw-mb-2">
                  <div className="tw-w-[12%]">Nama</div>
                  <div className="tw-w-[40%]">: {state.namasiswa}</div>
                  <div className="tw-w-[20%]">Semester</div>
                  <div className="tw-w-[30%]">
                    : {state.semester === "1" ? "Ganjil" : "Genap"}
                  </div>
                </div>
                <div className="tw-flex tw-justify-between">
                  <div className="tw-w-[12%]">Kelas</div>
                  <div className="tw-w-[40%]">: {state.kelas}</div>
                  <div className="tw-w-[20%]">Tahun Ajaran</div>
                  <div className="tw-w-[30%]">
                    :{" "}
                    {Array.from({ length: 6 }, (_, i) => i + 1).includes(
                      currentMonth
                    )
                      ? `${currentYear - 1}/${currentYear}`
                      : `${currentYear}/${currentYear + 1}`}
                  </div>
                </div>
              </div>
              {/* end of header */}

              {/* body */}
              <div className="tw-w-full tw-py-1 tw-text-[10px] tw-mt-3 md:tw-text-base">
                {/* nilai pelajaran */}
                <div className="tw-h-[40px] tw-flex tw-justify-between tw-text-[10px] md:tw-text-base">
                  <div className="border-element tw-text-center tw-w-[6%]">
                    No.
                  </div>
                  <div className="border-element tw-w-[25%]">
                    Mata Pelajaran
                  </div>
                  <div className="border-element tw-text-center tw-w-[6%]">
                    KKM
                  </div>
                  <div className="border-element tw-text-center tw-w-[6%]">
                    Nilai
                  </div>
                  <div className="border-element tw-text-center tw-w-[6%]">
                    Rata-Rata
                  </div>
                  <div className="tw-text-center tw-w-[2%]"></div>
                  <div className="border-element tw-text-center tw-w-[6%]">
                    المعدل التراكمي
                  </div>
                  <div className="border-element tw-text-center tw-w-[6%]">
                    النتيجة
                  </div>
                  <div className="border-element tw-text-center tw-w-[6%]">
                    الدرجة الصغرى
                  </div>
                  <div className="border-element tw-text-right tw-w-[25%]">
                    المواد الدراسية
                  </div>
                  <div className="border-element tw-text-center tw-w-[6%]">
                    الرقم
                  </div>
                </div>

                {state.dataRapor.kategori.map((item: any, index: number) => (
                  <>
                    <div
                      className="tw-h-[40px] tw-flex tw-justify-between tw-text-[10px] md:tw-text-base"
                      key={index}
                    >
                      <div className="border-element tw-text-center tw-w-[49%] tw-font-bold">
                        {getCategoryName(item.kategori)}
                      </div>
                      <div className="tw-text-center tw-w-[2%]"></div>
                      <div className="border-element tw-text-center tw-w-[49%]">
                        {item.kategori}
                      </div>
                    </div>

                    {item.nilai.map((nilai: any, nilaiIndex: number) => (
                      <div
                        className="tw-h-[40px] tw-flex tw-justify-between tw-text-[10px] md:tw-text-base"
                        key={nilaiIndex}
                      >
                        <div className="border-element tw-text-center tw-w-[6%]">
                          {nilai.no}
                        </div>
                        <div className="border-element tw-w-[25%]">
                          {nilai.namamapel}
                        </div>
                        <div className="border-element tw-text-center tw-w-[6%]">
                          {nilai.nilaikkm}
                        </div>
                        <div
                          className={`border-element tw-text-center tw-w-[6%] ${
                            nilai.nilaikkm > nilai.angka
                              ? "tw-text-red-600"
                              : ""
                          }`}
                        >
                          {nilai.angka}
                        </div>
                        <div className="border-element tw-text-center tw-w-[6%]">
                          {nilai.ratarata}
                        </div>
                        <div className="tw-text-center tw-w-[2%]"></div>
                        <div className="border-element tw-text-center tw-w-[6%]">
                          {nilai.ratarata}
                        </div>
                        <div
                          className={`border-element tw-text-center tw-w-[6%] ${
                            nilai.nilaikkm > nilai.angka
                              ? "tw-text-red-600"
                              : ""
                          }`}
                        >
                          {nilai.angka}
                        </div>
                        <div className="border-element tw-text-center tw-w-[6%]">
                          {nilai.nilaikkm}
                        </div>
                        <div className="border-element tw-text-right tw-w-[25%]">
                          {nilai.arabic}
                        </div>
                        <div className="border-element tw-text-center tw-w-[6%]">
                          {nilai.no}
                        </div>
                      </div>
                    ))}
                  </>
                ))}
                {/* end of nilai pelajaran */}

                {/* jumlah nilai */}
                <div className="tw-h-[40px] tw-flex tw-justify-between tw-text-[10px] md:tw-text-base">
                  <div className="border-element tw-text-center tw-w-[31%]">
                    Jumlah Nilai
                  </div>
                  <div className="border-element tw-text-center tw-w-[18%]">
                    {state.totalNilai.replaceAll(",", ".")}
                  </div>
                  <div className="tw-text-center tw-w-[2%]"></div>
                  <div className="border-element tw-text-center tw-w-[18%]">
                    {state.totalNilai.replaceAll(",", ".")}
                  </div>
                  <div className="border-element tw-text-center tw-w-[31%]">
                    مجموع الدرجات
                  </div>
                </div>
                {/* end of jumlah nilai */}

                {/* rata-rata nilai */}
                <div className="tw-h-[40px] tw-flex tw-justify-between tw-text-[10px] md:tw-text-base">
                  <div className="border-element tw-text-center tw-w-[31%]">
                    Rata-Rata
                  </div>
                  <div className="border-element tw-text-center tw-w-[18%]">
                    {state.rataNilai.replaceAll(",", ".")}
                  </div>
                  <div className="tw-text-center tw-w-[2%]"></div>
                  <div className="border-element tw-text-center tw-w-[18%]">
                    {state.rataNilai.replaceAll(",", ".")}
                  </div>
                  <div className="border-element tw-text-center tw-w-[31%]">
                    المعدل التراكمى
                  </div>
                </div>
                {/* end of rata-rata nilai */}

                {/* ranking */}
                <div className="tw-h-[40px] tw-flex tw-justify-between tw-text-[10px] md:tw-text-base">
                  <div className="border-element tw-text-center tw-w-[31%]">
                    Ranking
                  </div>
                  <div className="border-element tw-text-center tw-w-[18%]">
                    {state.dataRapor.peringkat[0].peringkat}
                  </div>
                  <div className="tw-text-center tw-w-[2%]"></div>
                  <div className="border-element tw-text-center tw-w-[18%]">
                    {state.dataRapor.peringkat[0].peringkat}
                  </div>
                  <div className="border-element tw-text-center tw-w-[31%]">
                    رتبته فى مستواه
                  </div>
                </div>

                <div className="tw-h-[40px] tw-flex tw-justify-between tw-text-[10px] md:tw-text-base">
                  <div className="border-element tw-text-center tw-w-[31%]">
                    Jumlah Santri
                  </div>
                  <div className="border-element tw-text-center tw-w-[18%]">
                    {state.dataRapor.peringkat[0].dari}
                  </div>
                  <div className="tw-text-center tw-w-[2%]"></div>
                  <div className="border-element tw-text-center tw-w-[18%]">
                    {state.dataRapor.peringkat[0].dari}
                  </div>
                  <div className="border-element tw-text-center tw-w-[31%]">
                    عدد الطلاب فى الفصل
                  </div>
                </div>
                {/* end of ranking */}

                {/* kepribadian & absen */}
                <div className="tw-h-[40px] tw-flex tw-justify-between tw-text-[10px] md:tw-text-base">
                  <div className="border-element tw-text-center tw-w-[49%]">
                    Kepribadian Santri
                  </div>
                  <div className="tw-text-center tw-w-[2%]"></div>
                  <div className="border-element tw-text-center tw-w-[49%]">
                    Ketidakhadiran
                  </div>
                </div>

                <div className="tw-h-[40px] tw-flex tw-justify-between tw-text-[10px] md:tw-text-base">
                  <div className="border-element tw-text-center tw-w-[31%]">
                    Perilaku
                  </div>
                  <div className="border-element tw-text-center tw-w-[18%]">
                    {state.ekskul != null && state.ekskul.length > 0
                      ? state.ekskul[0].nilai_perilaku
                      : "-"}
                  </div>
                  <div className="tw-text-center tw-w-[2%]"></div>
                  <div className="border-element tw-text-center tw-w-[12%]">
                    Absensi
                  </div>
                  <div className="border-element tw-text-center tw-w-[37%]">
                    Jumlah
                  </div>
                </div>

                <div className="tw-h-[40px] tw-flex tw-justify-between tw-text-[10px] md:tw-text-base">
                  <div className="border-element tw-text-center tw-w-[31%]">
                    Kedisiplinan
                  </div>
                  <div className="border-element tw-text-center tw-w-[18%]">
                    {state.ekskul != null && state.ekskul.length > 0
                      ? state.ekskul[0].nilai_kedisiplinan
                      : "-"}
                  </div>
                  <div className="tw-text-center tw-w-[2%]"></div>
                  <div className="border-element tw-text-center tw-w-[12%]">
                    Sakit
                  </div>
                  <div className="border-element tw-text-center tw-w-[6%]">
                    {state.absen.sakit}
                  </div>
                  <div className="border-element tw-text-center tw-w-[31%]">
                    Jam Pelajaran
                  </div>
                </div>

                <div className="tw-h-[40px] tw-flex tw-justify-between tw-text-[10px] md:tw-text-base">
                  <div className="border-element tw-text-center tw-w-[31%]">
                    Kerapihan
                  </div>
                  <div className="border-element tw-text-center tw-w-[18%]">
                    {state.ekskul != null && state.ekskul.length > 0
                      ? state.ekskul[0].nilai_kerapihan
                      : "-"}
                  </div>
                  <div className="tw-text-center tw-w-[2%]"></div>
                  <div className="border-element tw-text-center tw-w-[12%]">
                    Izin
                  </div>
                  <div className="border-element tw-text-center tw-w-[6%]">
                    {state.absen.ijin}
                  </div>
                  <div className="border-element tw-text-center tw-w-[31%]">
                    Jam Pelajaran
                  </div>
                </div>

                <div className="tw-h-[40px] tw-flex tw-justify-between tw-text-[10px] md:tw-text-base">
                  <div className="border-element tw-text-center tw-w-[31%]">
                    Kebersihan
                  </div>
                  <div className="border-element tw-text-center tw-w-[18%]">
                    {state.ekskul != null && state.ekskul.length > 0
                      ? state.ekskul[0].nilai_kebersihan
                      : "-"}
                  </div>
                  <div className="tw-text-center tw-w-[2%]"></div>
                  <div className="border-element tw-text-center tw-w-[12%]">
                    Alpa
                  </div>
                  <div className="border-element tw-text-center tw-w-[6%]">
                    {state.absen.alpa}
                  </div>
                  <div className="border-element tw-text-center tw-w-[31%]">
                    Jam Pelajaran
                  </div>
                </div>
                {/* end of kepribadian & absen */}

                {state.semester === "2" && (
                  <div className="tw-mt-2 tw-h-[40px] tw-text-[10px] md:tw-text-base">
                    <div className="border-element tw-w-[80%]">
                      <div>Keputusan : </div>
                      <div>
                        Berdasarkan hasil yang dicapai pada semester 1 dan 2,
                        peserta didik ditetapkan :{" "}
                        <span className="tw-font-bold">
                          {state.ekskul != null && state.ekskul.length > 0
                            ? state.ekskul[0].naikkelas
                            : "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {/* end of body */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
